(function () {
  if (window.__cart26UpgradeBound) return;
  window.__cart26UpgradeBound = true;

  function cartRootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function closest(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }

  function qs(root, sel) {
    return (root || document).querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  function getSectionIds() {
    var ids = [];
    var mini = document.querySelector('xo-cart-mini');
    var cart = document.querySelector('xo-cart');
    if (mini && mini.id) ids.push(mini.id);
    if (cart && cart.id) ids.push(cart.id);
    return ids;
  }

  function currentCartCount() {
    try {
      var cart = window.xoStore && typeof window.xoStore.get === 'function' && window.xoStore.get('xo-cart');
      if (cart && typeof cart.size === 'number') return cart.size;
    } catch (e) {}
    return 0;
  }

  function isCartAjaxUrl(url) {
    return /\/cart\/(change|add|update)\.js(\?|$)/.test(String(url || ''));
  }

  function isCartWriteUrl(url) {
    return /\/cart\/(change|add|update|clear)(\.js)?(\?|$)/.test(String(url || ''));
  }

  function requestMethod(input, init) {
    if (init && init.method) return String(init.method).toUpperCase();
    if (typeof Request !== 'undefined' && input instanceof Request && input.method) {
      return String(input.method).toUpperCase();
    }
    return 'GET';
  }

  function requestHeaders(input, init) {
    if (init && init.headers) return init.headers;
    if (typeof Request !== 'undefined' && input instanceof Request) return input.headers;
    return null;
  }

  function isBfDiscountRequest(input, init) {
    var headers = requestHeaders(input, init);
    if (!headers) return false;
    if (typeof Headers !== 'undefined' && headers instanceof Headers) {
      return headers.get('X-Pongbot-Bf-Discount') === '1';
    }
    return headers['X-Pongbot-Bf-Discount'] === '1' || headers['x-pongbot-bf-discount'] === '1';
  }

  function isNonJsonCartResponse(res) {
    if (!res) return false;
    if (res.status === 429) return true;
    var ct = (res.headers && res.headers.get && res.headers.get('content-type')) || '';
    if (ct.indexOf('application/json') !== -1) return false;
    return !res.ok || res.status === 429;
  }

  function quietCartPayload() {
    return { item_count: currentCartCount(), sections: {} };
  }

  function quietCartJsonResponse() {
    return new Response(JSON.stringify(quietCartPayload()), {
      status: 200,
      headers: { 'Content-Type': 'application/json' },
    });
  }

  window.__pongbotCartAjax = window.__pongbotCartAjax || { depth: 0 };

  if (!window.__cart26FetchWrapped && typeof window.fetch === 'function') {
    window.__cart26FetchWrapped = true;
    var nativeFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = requestMethod(input, init);
      var write = method !== 'GET' && isCartWriteUrl(url);
      var raw = isBfDiscountRequest(input, init);
      if (write) window.__pongbotCartAjax.depth++;
      var pending;
      try {
        pending = nativeFetch(input, init);
      } catch (err) {
        if (write) window.__pongbotCartAjax.depth = Math.max(0, window.__pongbotCartAjax.depth - 1);
        return Promise.reject(err);
      }
      return pending.then(function (res) {
        if (!raw && isCartAjaxUrl(url) && isNonJsonCartResponse(res)) return quietCartJsonResponse();
        return res;
      }).finally(function () {
        if (!write) return;
        window.__pongbotCartAjax.depth = Math.max(0, window.__pongbotCartAjax.depth - 1);
        if (!raw && window.PongbotBfDiscount && typeof window.PongbotBfDiscount.onCartWriteEnd === 'function') {
          window.PongbotBfDiscount.onCartWriteEnd();
        }
      });
    };
  }

  function isNoisyCartToast(content) {
    return /Failed to execute|Unexpected token|Too Many Requests|\b429\b/i.test(String(content == null ? '' : content));
  }

  function wrapXoToast() {
    var toast = window.xoToast;
    if (!toast || typeof toast.push !== 'function' || toast.__cart26Quiet) return;
    var origPush = toast.push.bind(toast);
    toast.push = function (opts) {
      var content = opts && typeof opts === 'object' ? opts.content : opts;
      if (isNoisyCartToast(content)) return;
      return origPush.apply(this, arguments);
    };
    toast.__cart26Quiet = true;
  }

  wrapXoToast();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wrapXoToast);
  }

  function mergeXoCart(data) {
    if (!data || !window.xoStore || typeof window.xoStore.set !== 'function') {
      if (window.location.pathname.indexOf('/cart') !== -1) window.location.reload();
      return;
    }
    window.xoStore.set('xo-cart', function (prev) {
      var next = Object.assign({}, prev || {});
      if (typeof data.item_count === 'number') next.size = data.item_count;
      if (data.sections && typeof data.sections === 'object') {
        next.sections = Object.assign({}, (prev && prev.sections) || {}, data.sections);
      }
      next.changeLineLoading = -1;
      next.addIdLoading = '';
      return next;
    })('cart26-upgrade');
  }

  function cartPost(path, body) {
    var payload = Object.assign({}, body);
    var sections = getSectionIds();
    if (sections.length) {
      payload.sections = sections;
      payload.section_url = window.location.pathname || '/';
    }
    return fetch(cartRootUrl() + path.replace(/^\//, ''), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(payload),
    }).then(function (res) {
      if (res.status === 429 || isNonJsonCartResponse(res)) {
        return quietCartPayload();
      }
      return res.json().then(function (data) {
        data = data || {};
        if (!res.ok || data.status === 422 || data.errors) {
          var err = data;
          err.ok = false;
          throw err;
        }
        return data;
      });
    });
  }

  function setPanel(root, tab) {
    if (!root) return;
    qsa(root, '.cart26-tab').forEach(function (btn) {
      btn.setAttribute('data-active', btn.getAttribute('data-tab') === tab ? 'true' : 'false');
    });
    qsa(root, '.cart26-panel').forEach(function (panel) {
      panel.setAttribute('data-active', panel.getAttribute('data-panel') === tab ? 'true' : 'false');
    });
    var tabs = qs(root, '.cart26-tabs');
    if (tabs) tabs.setAttribute('data-tab', tab);
  }

  function existingDiscountCodes(root) {
    return qsa(root, '.cart26-tag')
      .map(function (el) {
        return (el.getAttribute('data-cart26-code') || el.textContent || '').trim();
      })
      .filter(Boolean);
  }

  function currentCartNote(root) {
    var input = qs(root, '[name="note"]');
    return input && typeof input.value === 'string' ? input.value : '';
  }

  function appliedDiscountCodes(data) {
    var out = [];
    var seen = {};
    function add(code) {
      var key = String(code || '').trim();
      if (!key) return;
      var id = key.toUpperCase();
      if (seen[id]) return;
      seen[id] = true;
      out.push(key);
    }
    ((data && data.discount_codes) || []).forEach(function (item) {
      if (!item || item.applicable === false) return;
      add(item.code);
    });
    ((data && data.cart_level_discount_applications) || []).forEach(function (item) {
      if (!item || item.type === 'automatic') return;
      add(item.title || item.code);
    });
    return out;
  }

  function typedCodesApplied(typed, data) {
    if (!data || (!Array.isArray(data.discount_codes) && !Array.isArray(data.cart_level_discount_applications))) {
      return true;
    }
    var applied = appliedDiscountCodes(data).map(function (code) {
      return code.toUpperCase();
    });
    return (typed || []).every(function (code) {
      return applied.indexOf(String(code).toUpperCase()) !== -1;
    });
  }

  function uniqueDiscountCodes(list) {
    var seen = {};
    var out = [];
    (list || []).forEach(function (code) {
      var key = String(code || '').trim();
      if (!key) return;
      var id = key.toUpperCase();
      if (seen[id]) return;
      seen[id] = true;
      out.push(key);
    });
    return out;
  }

  function showPromoStatus(root, type, text) {
    var el = qs(root, '.cart26-promo__status');
    if (!el) return;
    el.setAttribute('data-visible', 'true');
    el.classList.toggle('cart26-promo__status--error', type === 'error');
    var label = qs(el, '[data-promo-text]');
    if (label) label.textContent = text;
  }

  function klaviyoIds(box) {
    var company = (box.getAttribute('data-klaviyo-company') || '').trim();
    var list = (box.getAttribute('data-klaviyo-list') || '').trim();
    if (!company || !list) {
      var nl = document.querySelector('[data-pongbot26-klaviyo-company-id]');
      if (nl) {
        company = company || (nl.getAttribute('data-pongbot26-klaviyo-company-id') || '').trim();
        list = list || (nl.getAttribute('data-pongbot26-klaviyo-list-id') || '').trim();
      }
    }
    return { company: company, list: list };
  }

  var subscribeOpenKey = 'cart26-subscribe-open';

  function readSubscribeOpen() {
    try {
      var value = window.sessionStorage.getItem(subscribeOpenKey);
      if (value === 'true' || value === 'false') return value;
    } catch (e) {}
    return '';
  }

  function writeSubscribeOpen(open) {
    try {
      window.sessionStorage.setItem(subscribeOpenKey, open);
    } catch (e) {}
  }

  function applySubscribeOpen(box, open) {
    if (!box) return;
    box.setAttribute('data-open', open);
    box.setAttribute('data-user-toggled', 'true');
    var bar = qs(box, '.cart26-subscribe__bar');
    if (bar) bar.setAttribute('aria-expanded', open);
  }

  function restoreSubscribeOpen(root) {
    var saved = readSubscribeOpen();
    if (!saved) return;
    qsa(root || document, '.cart26-subscribe').forEach(function (box) {
      applySubscribeOpen(box, saved);
    });
  }

  document.addEventListener(
    'invalid',
    function (event) {
      var input = event.target;
      if (!input || !input.matches || !input.matches('.cart26-subscribe__input')) return;
      input.setCustomValidity('Enter your email.');
    },
    true
  );

  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('.cart26-subscribe__input')) return;
    input.setCustomValidity('');
  });

  function submitSubscribe(box, form) {
    var input = qs(form, 'input[type="email"]');
    var msg = qs(box, '.cart26-subscribe__msg');
    var email = input && input.value ? input.value.trim() : '';
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      if (msg) {
        msg.hidden = false;
        msg.classList.add('cart26-subscribe__msg--error');
        msg.textContent = 'Please enter a valid email address.';
      }
      return;
    }
    var ids = klaviyoIds(box);
    if (ids.company && ids.list) {
      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(ids.company), {
        method: 'POST',
        headers: {
          'content-type': 'application/vnd.api+json',
          revision: '2026-01-15',
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Cart drawer subscribe',
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email },
                },
              },
            },
            relationships: { list: { data: { type: 'list', id: ids.list } } },
          },
        }),
      })
        .then(function (res) {
          if (res.status === 202 || res.ok) return;
          throw new Error('fail');
        })
        .then(function () {
          if (msg) {
            msg.hidden = false;
            msg.classList.remove('cart26-subscribe__msg--error');
            msg.textContent = 'Thanks for subscribing.';
          }
          form.reset();
        })
        .catch(function () {
          if (msg) {
            msg.hidden = false;
            msg.classList.add('cart26-subscribe__msg--error');
            msg.textContent = 'Subscription failed. Please try again.';
          }
        });
      return;
    }
    form.submit();
  }

  function collectChildUpdates(parentKey, parentProduct) {
    var updates = {};
    var sels = [];
    if (parentKey) sels.push('[data-cart26-child-of="' + parentKey + '"]');
    if (parentProduct) sels.push('[data-cart26-child-product="' + parentProduct + '"]');
    if (!sels.length) return updates;
    qsa(document, sels.join(',')).forEach(function (child) {
      var key = child.getAttribute('data-line-key');
      if (key) updates[key] = 0;
    });
    return updates;
  }

  var EXPLORE_DRAG_THRESHOLD = 6;
  var exploreSuppressClickUntil = 0;
  var exploreDrag = {
    track: null,
    startX: 0,
    startScroll: 0,
    moved: false,
  };

  function exploreCanScroll(track) {
    if (!track || track.clientWidth < 2) return null;
    var max = track.scrollWidth - track.clientWidth;
    if (max <= 2) return { atStart: true, atEnd: true };
    var left = track.scrollLeft;
    return {
      atStart: left <= 2,
      atEnd: left >= max - 2,
    };
  }

  function setExploreArrowState(btn, dim) {
    if (!btn) return;
    btn.setAttribute('data-explore-disabled', dim ? 'true' : 'false');
    btn.setAttribute('aria-disabled', dim ? 'true' : 'false');
    btn.removeAttribute('disabled');
    var img = qs(btn, 'img');
    var src = dim ? btn.getAttribute('data-icon-off') : btn.getAttribute('data-icon-on');
    if (img && src) img.setAttribute('src', src);
  }

  function updateExploreNav(explore) {
    if (!explore) return;
    var track = qs(explore, '.cart26-explore__track');
    var state = exploreCanScroll(track);
    if (!state) return;
    qsa(explore, '[data-explore-prev]').forEach(function (btn) {
      setExploreArrowState(btn, state.atStart);
    });
    qsa(explore, '[data-explore-next]').forEach(function (btn) {
      setExploreArrowState(btn, state.atEnd);
    });
  }

  function updateAllExploreNav() {
    qsa(document, '.cart26-explore').forEach(updateExploreNav);
  }

  function exploreStep(track) {
    var card = qs(track, '.cart26-rec-card');
    if (!card) return 184;
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 10;
    return card.getBoundingClientRect().width + gap;
  }

  function bindExploreTracks() {
    qsa(document, '.cart26-explore__track').forEach(function (track) {
      if (track.getAttribute('data-cart26-explore-bound') === 'true') return;
      track.setAttribute('data-cart26-explore-bound', 'true');
      track.addEventListener(
        'scroll',
        function () {
          updateExploreNav(closest(track, '.cart26-explore'));
        },
        { passive: true }
      );
      if (typeof ResizeObserver !== 'undefined') {
        var ro = new ResizeObserver(function () {
          updateExploreNav(closest(track, '.cart26-explore'));
        });
        ro.observe(track);
      }
    });
    updateAllExploreNav();
  }

  function watchCartModalExplore() {
    var modal = document.querySelector("xo-modal[xo-name='cart']");
    if (!modal || modal.getAttribute('data-cart26-explore-modal') === 'true') return;
    modal.setAttribute('data-cart26-explore-modal', 'true');
    var sync = function () {
      requestAnimationFrame(function () {
        requestAnimationFrame(updateAllExploreNav);
      });
    };
    var obs = new MutationObserver(function () {
      if (modal.hasAttribute('xo-active')) sync();
    });
    obs.observe(modal, { attributes: true, attributeFilter: ['xo-active'] });
    if (modal.hasAttribute('xo-active')) sync();
  }

  function endExploreDrag() {
    if (!exploreDrag.track) return;
    exploreDrag.track.classList.remove('is-dragging');
    exploreDrag.track.style.scrollBehavior = '';
    if (exploreDrag.moved) exploreSuppressClickUntil = Date.now() + 400;
    updateExploreNav(closest(exploreDrag.track, '.cart26-explore'));
    exploreDrag.track = null;
    exploreDrag.moved = false;
  }

  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    var track = closest(event.target, '.cart26-explore__track');
    if (!track) return;
    exploreDrag.track = track;
    exploreDrag.startX = event.clientX;
    exploreDrag.startScroll = track.scrollLeft;
    exploreDrag.moved = false;
    track.classList.add('is-dragging');
    track.style.scrollBehavior = 'auto';
  });

  document.addEventListener('pointermove', function (event) {
    if (!exploreDrag.track) return;
    var dx = event.clientX - exploreDrag.startX;
    if (Math.abs(dx) > EXPLORE_DRAG_THRESHOLD) exploreDrag.moved = true;
    if (!exploreDrag.moved) return;
    event.preventDefault();
    exploreDrag.track.scrollLeft = exploreDrag.startScroll - dx;
  });

  document.addEventListener('pointerup', endExploreDrag);
  document.addEventListener('pointercancel', endExploreDrag);

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    if (Date.now() < exploreSuppressClickUntil && closest(target, '.cart26-explore__track')) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    var checkout = closest(target, '[data-cart26-checkout]');
    if (checkout) {
      event.preventDefault();
      event.stopPropagation();
      var checkoutUrl =
        checkout.getAttribute('href') || cartRootUrl() + 'checkout';
      window.location.href = checkoutUrl;
      return;
    }

    var subBar = closest(target, '.cart26-subscribe__bar');
    if (subBar) {
      var box = closest(subBar, '.cart26-subscribe');
      if (box) {
        var open = box.getAttribute('data-open') === 'true' ? 'false' : 'true';
        applySubscribeOpen(box, open);
        writeSubscribeOpen(open);
      }
      return;
    }

    var likeBtn = closest(target, '.cart26-like__toggle');
    if (likeBtn) {
      var like = closest(likeBtn, '.cart26-like');
      if (like) like.setAttribute('data-open', like.getAttribute('data-open') === 'true' ? 'false' : 'true');
      return;
    }

    var explorePrev = closest(target, '[data-explore-prev]');
    var exploreNext = closest(target, '[data-explore-next]');
    if (explorePrev || exploreNext) {
      event.preventDefault();
      if (
        (explorePrev && explorePrev.getAttribute('data-explore-disabled') === 'true') ||
        (exploreNext && exploreNext.getAttribute('data-explore-disabled') === 'true')
      ) {
        return;
      }
      var explore = closest(target, '.cart26-explore');
      var track = explore && qs(explore, '.cart26-explore__track');
      if (track) {
        track.scrollBy({ left: explorePrev ? -exploreStep(track) : exploreStep(track), behavior: 'smooth' });
      }
      return;
    }

    var tab = closest(target, '.cart26-tab');
    if (tab) {
      var tabRoot = closest(tab, '.cart26-drawer__footer') || closest(tab, '.cart26-drawer, .cart26-page');
      var next = tab.getAttribute('data-tab') || 'note';
      if (tab.getAttribute('data-active') === 'true') next = '';
      setPanel(tabRoot, next);
      return;
    }

    var promoTag = closest(target, '.cart26-tag');
    if (promoTag) {
      event.preventDefault();
      var tagRoot = closest(promoTag, '.cart26-drawer, .cart26-page') || document;
      var removeCode = (promoTag.getAttribute('data-cart26-code') || promoTag.textContent || '').trim();
      if (window.PongbotBfDiscount && typeof window.PongbotBfDiscount.removeCode === 'function') {
        window.PongbotBfDiscount.removeCode(removeCode)
          .then(function (result) {
            var promoBtn = qs(tagRoot, '.cart26-tab[data-tab="promo"]');
            var left = result && result.codes ? result.codes.length : 0;
            if (promoBtn) promoBtn.setAttribute('data-filled', left ? 'true' : 'false');
          })
          .catch(function () {
            showPromoStatus(tagRoot, 'error', 'Could not remove code');
          });
        return;
      }
      var remaining = uniqueDiscountCodes(existingDiscountCodes(tagRoot)).filter(function (code) {
        return code.toUpperCase() !== removeCode.toUpperCase();
      });
      cartPost('cart/update.js', { discount: remaining.join(','), note: currentCartNote(tagRoot) })
        .then(function (data) {
          var promoBtn = qs(tagRoot, '.cart26-tab[data-tab="promo"]');
          if (promoBtn) promoBtn.setAttribute('data-filled', remaining.length ? 'true' : 'false');
          mergeXoCart(data);
        })
        .catch(function () {
          showPromoStatus(tagRoot, 'error', 'Could not remove code');
        });
      return;
    }

    if (closest(target, '[data-cart26-acc-qty]')) {
      event.stopPropagation();
      return;
    }

    var accRemove = closest(target, '[data-cart26-acc-remove]');
    if (accRemove) {
      event.preventDefault();
      event.stopPropagation();
      var removeKey = accRemove.getAttribute('data-line-key');
      if (!removeKey) {
        var removeRow = closest(accRemove, '.cart26-like__row');
        removeKey = removeRow && removeRow.getAttribute('data-line-key');
      }
      if (!removeKey) return;
      var updates = {};
      updates[removeKey] = 0;
      cartPost('cart/update.js', { updates: updates }).then(mergeXoCart).catch(function () {});
      return;
    }

    var recAdd = closest(target, '[data-cart26-rec-add]');
    if (recAdd) {
      event.preventDefault();
      if (Date.now() < exploreSuppressClickUntil) return;
      var recVariantId = Number(recAdd.getAttribute('data-variant-id') || 0);
      if (!recVariantId) return;
      cartPost('cart/add.js', {
        items: [{ id: recVariantId, quantity: 1 }],
      })
        .then(mergeXoCart)
        .catch(function () {});
      return;
    }

    var accAdd = closest(target, '[data-cart26-acc-add]');
    if (accAdd) {
      event.preventDefault();
      event.stopPropagation();
      if (accAdd.disabled || accAdd.getAttribute('aria-busy') === 'true') return;
      var variantId = Number(accAdd.getAttribute('data-variant-id') || 0);
      if (!variantId) return;
      var addRow = closest(accAdd, '.cart26-like__row');
      if (addRow && addRow.classList.contains('is-leaving')) return;
      var addInput = addRow && qs(addRow, '[data-cart26-acc-qty]');
      var addQty = Math.max(
        1,
        parseInt((addInput && addInput.value) || (addRow && addRow.getAttribute('data-qty')), 10) || 1
      );
      accAdd.disabled = true;
      accAdd.setAttribute('aria-busy', 'true');
      if (addRow) addRow.classList.add('is-leaving');
      var leaveDone = waitLikeLeave(addRow);
      cartPost('cart/add.js', {
        items: [
          {
            id: variantId,
            quantity: addQty,
            properties: {
              _accessory: '1',
              _parent_key: accAdd.getAttribute('data-parent-key') || '',
            },
          },
        ],
      })
        .then(function (data) {
          return leaveDone.then(function () {
            return data;
          });
        })
        .then(function (data) {
          removeLikeShownId(variantId);
          lastAddedVariantId = String(variantId);
          mergeXoCart(data);
        })
        .catch(function () {
          if (addRow) addRow.classList.remove('is-leaving');
          accAdd.disabled = false;
          accAdd.removeAttribute('aria-busy');
        });
      return;
    }

    var parentRemove = closest(target, '[data-cart26-parent-key]');
    if (parentRemove) {
      var childUpdates = collectChildUpdates(
        parentRemove.getAttribute('data-cart26-parent-key'),
        parentRemove.getAttribute('data-cart26-parent-product')
      );
      if (Object.keys(childUpdates).length) {
        cartPost('cart/update.js', { updates: childUpdates }).catch(function () {});
      }
    }
  });

  function applyAccQtyInput(input) {
    var row = closest(input, '.cart26-like__row');
    if (!row) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 1;
    var lineKey = row.getAttribute('data-line-key');
    if (lineKey) {
      if (qty < 1) qty = 0;
      if (qty > 0) input.value = String(qty);
      var qtyUpdates = {};
      qtyUpdates[lineKey] = qty;
      cartPost('cart/update.js', { updates: qtyUpdates }).then(mergeXoCart).catch(function () {});
      return;
    }
    if (qty < 1) qty = 1;
    row.setAttribute('data-qty', String(qty));
    input.value = String(qty);
  }

  document.addEventListener('keydown', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-cart26-acc-qty]')) return;
    if (event.key === 'Enter') {
      event.preventDefault();
      input.blur();
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-cart26-acc-qty]')) return;
    applyAccQtyInput(input);
  });

  document.addEventListener('focusout', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-cart26-acc-qty]')) return;
    if (String(input.value).trim() === '') applyAccQtyInput(input);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.getAttribute) return;

    var subBox = closest(form, '.cart26-subscribe');
    if (subBox && form.closest('.cart26-subscribe')) {
      event.preventDefault();
      submitSubscribe(subBox, form);
      return;
    }

    if (form.matches('[data-cart26-promo-form]')) {
      event.preventDefault();
      var root = closest(form, '.cart26-drawer, .cart26-page') || document;
      var input = qs(form, 'input[name="discount"]');
      var typed = (input && input.value ? input.value : '')
        .split(/[/,]/)
        .map(function (part) {
          return part.trim();
        })
        .filter(Boolean);
      if (!typed.length) {
        showPromoStatus(root, 'error', 'Invalid code');
        return;
      }
      if (window.PongbotBfDiscount && typeof window.PongbotBfDiscount.applyManual === 'function') {
        window.PongbotBfDiscount.applyManual(typed)
          .then(function (result) {
            if (!result || !result.ok) {
              showPromoStatus(root, 'error', 'Invalid code');
              return;
            }
            showPromoStatus(root, 'ok', 'Code applied');
            if (input) input.value = '';
            var promoBtn = qs(root, '.cart26-tab[data-tab="promo"]');
            if (promoBtn) promoBtn.setAttribute('data-filled', 'true');
            var footer = closest(form, '.cart26-drawer__footer');
            if (footer) setPanel(footer, '');
          })
          .catch(function () {
            showPromoStatus(root, 'error', 'Invalid code');
          });
        return;
      }
      var nextCodes = uniqueDiscountCodes(existingDiscountCodes(root).concat(typed));
      cartPost('cart/update.js', { discount: nextCodes.join(','), note: currentCartNote(root) })
        .then(function (data) {
          if (!typedCodesApplied(typed, data)) {
            showPromoStatus(root, 'error', 'Invalid code');
            return;
          }
          showPromoStatus(root, 'ok', 'Code applied');
          if (input) input.value = '';
          var promoBtn = qs(root, '.cart26-tab[data-tab="promo"]');
          if (promoBtn) promoBtn.setAttribute('data-filled', 'true');
          var footer = closest(form, '.cart26-drawer__footer');
          if (footer) setPanel(footer, '');
          mergeXoCart(data);
        })
        .catch(function () {
          showPromoStatus(root, 'error', 'Invalid code');
        });
      return;
    }

    if (form.matches('[data-cart26-note-form]')) {
      event.preventDefault();
      var noteRoot = closest(form, '.cart26-drawer, .cart26-page') || document;
      var drawerFooter = closest(form, '.cart26-drawer__footer');
      var noteInput = qs(form, '[name="note"]');
      var note = noteInput ? noteInput.value : '';
      var noteStatus = qs(form, '[data-note-status]');
      cartPost('cart/update.js', { note: note })
        .then(function () {
          var tabBtn = qs(noteRoot, '.cart26-tab[data-tab="note"]');
          if (tabBtn) tabBtn.setAttribute('data-filled', note.trim() ? 'true' : 'false');
          if (drawerFooter) setPanel(drawerFooter, '');
          if (noteStatus) {
            noteStatus.hidden = true;
            noteStatus.textContent = '';
          }
        })
        .catch(function () {
          if (noteStatus) {
            noteStatus.hidden = false;
            noteStatus.textContent = 'Note could not be saved';
          }
        });
    }
  });

  var LIKE_LIMIT = 4;
  var LIKE_SHOWN_KEY = 'cart26-ymal-shown';
  var LIKE_LEAVE_MS = 240;
  var lastAddedVariantId = '';

  function readLikeShown() {
    try {
      var parsed = JSON.parse(window.sessionStorage.getItem(LIKE_SHOWN_KEY) || '[]');
      if (Array.isArray(parsed)) return parsed.map(String).filter(Boolean);
    } catch (e) {}
    return [];
  }

  function writeLikeShown(ids) {
    try {
      window.sessionStorage.setItem(LIKE_SHOWN_KEY, JSON.stringify((ids || []).map(String)));
    } catch (e) {}
  }

  function removeLikeShownId(variantId) {
    var id = String(variantId || '');
    writeLikeShown(
      readLikeShown().filter(function (shownId) {
        return shownId !== id;
      })
    );
  }

  function shuffleLikeIds(ids) {
    var list = ids.slice();
    for (var i = list.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var swap = list[i];
      list[i] = list[j];
      list[j] = swap;
    }
    return list;
  }

  function waitLikeLeave(row) {
    return new Promise(function (resolve) {
      if (!row) {
        resolve();
        return;
      }
      var done = false;
      var finish = function () {
        if (done) return;
        done = true;
        resolve();
      };
      var onEnd = function (event) {
        if (event.target !== row) return;
        row.removeEventListener('transitionend', onEnd);
        finish();
      };
      row.addEventListener('transitionend', onEnd);
      setTimeout(finish, LIKE_LEAVE_MS + 40);
    });
  }

  function markEntering(el) {
    if (!el) return;
    el.classList.remove('is-entering');
    void el.offsetWidth;
    el.classList.add('is-entering');
    var onEnd = function () {
      el.classList.remove('is-entering');
      el.removeEventListener('animationend', onEnd);
    };
    el.addEventListener('animationend', onEnd);
  }

  function initYouMightAlsoLike() {
    var sections = qsa(document, '.cart26-like');
    if (!sections.length) return;

    var poolIds = [];
    var seenPool = {};
    qsa(document, '.cart26-like__row').forEach(function (row) {
      var id = String(row.getAttribute('data-variant-id') || '');
      if (!id || seenPool[id]) return;
      seenPool[id] = true;
      poolIds.push(id);
    });

    var prevShown = readLikeShown();
    var kept = prevShown.filter(function (id) {
      return seenPool[id];
    });
    var leftover = shuffleLikeIds(
      poolIds.filter(function (id) {
        return kept.indexOf(id) === -1;
      })
    );
    while (kept.length < LIKE_LIMIT && leftover.length) {
      kept.push(leftover.shift());
    }
    writeLikeShown(kept);

    var keptSet = {};
    kept.forEach(function (id) {
      keptSet[id] = true;
    });

    if (!kept.length) {
      sections.forEach(function (section) {
        section.hidden = true;
      });
      return;
    }

    sections.forEach(function (section) {
      var rows = qsa(section, '.cart26-like__row');
      var visibleCount = 0;
      section.setAttribute('data-like-ready', 'true');
      rows.forEach(function (row) {
        var id = String(row.getAttribute('data-variant-id') || '');
        var show = !!keptSet[id];
        row.classList.toggle('is-visible', show);
        row.classList.remove('is-leaving');
        if (show) visibleCount += 1;
        if (show && prevShown.length && prevShown.indexOf(id) === -1) {
          markEntering(row);
        } else {
          row.classList.remove('is-entering');
        }
      });
      section.hidden = visibleCount === 0;
    });

    if (lastAddedVariantId) {
      qsa(document, '.cart26-line[data-variant-id="' + lastAddedVariantId + '"]').forEach(markEntering);
      lastAddedVariantId = '';
    }
  }

  function repairDrawerLines() {
    var root = document.querySelector('.cart26-drawer');
    if (!root) return;
    var lines = qs(root, '.cart26-lines');
    if (!lines) return;
    var like = qs(lines, '.cart26-like');
    qsa(root, '.cart26-line').forEach(function (line) {
      if (lines.contains(line)) return;
      if (like) lines.insertBefore(line, like);
      else lines.appendChild(line);
    });
    renderCart26Debug(root);
  }

  function renderCart26Debug(root) {
    if (window.location.search.indexOf('cart26debug=1') === -1) return;
    var panel = document.getElementById('cart26-debug');
    if (!panel) {
      panel = document.createElement('pre');
      panel.id = 'cart26-debug';
      panel.setAttribute('style', 'position:fixed;right:8px;bottom:8px;z-index:99999;max-width:420px;max-height:40vh;overflow:auto;margin:0;padding:10px;background:#111;color:#9f9;font:11px/1.4 ui-monospace,monospace;white-space:pre-wrap;');
      document.body.appendChild(panel);
    }
    var rows = qsa(root, '.cart26-line').map(function (line, i) {
      var title = (qs(line, '.cart26-line__name') || {}).textContent || '';
      title = title.replace(/\s+/g, ' ').trim();
      var chain = [];
      var el = line;
      while (el && el !== root) {
        chain.push((el.className && String(el.className).split(' ')[0]) || el.tagName.toLowerCase());
        el = el.parentElement;
      }
      return i + 1 + '. ' + title + '\n   parent: ' + chain.join(' > ');
    });
    panel.textContent = 'cart26debug ' + rows.length + ' lines\n' + rows.join('\n');
  }

  function watchDrawerLines() {
    var body = document.querySelector('.cart26-drawer__body');
    if (!body || body.getAttribute('data-cart26-watch') === 'true') return;
    body.setAttribute('data-cart26-watch', 'true');
    var timer = null;
    var obs = new MutationObserver(function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(repairDrawerLines, 50);
    });
    obs.observe(body, { childList: true, subtree: true });
    repairDrawerLines();
  }

  function bootCart26Ui() {
    watchDrawerLines();
    bindExploreTracks();
    watchCartModalExplore();
    restoreSubscribeOpen();
    initYouMightAlsoLike();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootCart26Ui);
  } else {
    bootCart26Ui();
  }
  document.addEventListener('shopify:section:load', bootCart26Ui);
  window.addEventListener('resize', updateAllExploreNav);
  if (window.xoStore && typeof window.xoStore.subscribe === 'function') {
    window.xoStore.subscribe('xo-cart', function () {
      setTimeout(function () {
        repairDrawerLines();
        bindExploreTracks();
        restoreSubscribeOpen();
        initYouMightAlsoLike();
      }, 80);
    });
  }
})();
